import {
  EmptyState,
  SavedSkeleton,
  useSlidesLibraryStore,
} from "@modules/slides-library/shared";
import { IconSearch, IconTrash } from "@tabler/icons-react";
import { useMemo } from "react";
import type { TSavedSlide } from "@/shared/types";
import { useGetArchivedFolders, useGetArchivedSlides } from "../hooks";
import { ROOT_FOLDER_ID } from "../constants";
import { SingleArchivedSlide } from "./single-archived-slide";

export const RecentlyDeletedView = () => {
  const { data, isLoading, isFetching } = useGetArchivedSlides();
  const { folders } = useGetArchivedFolders();
  const activeFolderId = useSlidesLibraryStore((s) => s.folderId);
  const search = useSlidesLibraryStore((s) => s.search);

  const title = useMemo(() => {
    if (search) return `Search results for "${search}"`;
    if (activeFolderId === ROOT_FOLDER_ID) return "Recently deleted slides";
    const current = folders.find((f) => f._id === activeFolderId);
    return current?.title ?? "Recently deleted slides";
  }, [search, activeFolderId, folders]);

  const HeaderIcon = search ? IconSearch : IconTrash;

  return (
    <div>
      <div className="tw-flex tw-h-[52px] tw-items-start tw-justify-between tw-self-stretch tw-bg-white tw-py-4">
        <div className="tw-flex tw-flex-1 tw-items-start tw-px-6">
          <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2">
            <HeaderIcon className="tw-size-4 tw-shrink-0 tw-text-blue" stroke={1} />
            <span className="tw-font-sans tw-text-sm tw-font-medium tw-leading-5 tw-text-blue">
              {title}
            </span>
          </div>
        </div>
      </div>
      {!data?.length && !isLoading && !isFetching ? (
        <EmptyState variant={search ? "search" : "deleted"} />
      ) : (
        <div className="tw-grid tw-grid-cols-3 tw-gap-6 tw-px-6 tw-pb-4">
          {isLoading || isFetching ? (
            <SavedSkeleton.Slides />
          ) : (
            data?.map((slide: TSavedSlide) => (
              <SingleArchivedSlide key={slide._id} slide={slide} />
            ))
          )}
        </div>
      )}
    </div>
  );
};
